import { render, staticRenderFns } from "./DepartmentsHeaderDashboard.vue?vue&type=template&id=a4874da8"
import script from "./DepartmentsHeaderDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentsHeaderDashboard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports